import Debug from '../helpers/debug.js';
import { baseBuilder } from '../helpers/baseBuilder.js';
import { singer } from './singer/index.js';

const debug = Debug('commands:singer');

const command = 'singer <action>';

const desc = 'Develop and test singer taps and targets';

const builder = async function (yargs) {
  debug('builder', command);
  const base = await baseBuilder(yargs);
  return base.command(singer);
};

const handler = async function (argv) {
  debug('handler', command, argv);
};

export { command, desc, builder, handler };
